import React, { useMemo, useState } from 'react'
import { viewerTypes, getPrimaryDark } from '../../constants/constants'
import { boxActionColor } from '../../utils/styles'
import { selectComponent } from './Box'
import { useStore } from '../../store/store'

const SimulatedBox = ({ box, isSelected, setIsSelected, fromViewer }) => {
  const [isHovered, setIsHovered] = useState(false)
  const handleUnSelectBox = useStore(({ handleUnSelectBox }) => handleUnSelectBox)
  const accentColor = useStore(({ currentDocument }) => getPrimaryDark(currentDocument?.type === 'template'))

  const commonBox = useMemo(() => ({
    ...box,
    width: "100%",
    fromViewer,
    isSelected,
  }), [box, isSelected, fromViewer])

  const getOutline = () => {
    if (fromViewer === viewerTypes.DMZ || fromViewer === viewerTypes.PREVIEW) {
      return;
    }
    return isSelected ? '2px solid ' + accentColor : `2px solid ${boxActionColor({
      hovered: isHovered
    })}`
  }

  return <div
    style={{
      outline: getOutline(),
    }}
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    onClick={(e) => {
      handleUnSelectBox();
      setIsSelected(true);
      e.stopPropagation()
    }}
  >
    {selectComponent(commonBox, false, isSelected)}
  </div>
}

export default SimulatedBox
